import axios from "../api/axios";

export const getTeleconsultation = async (token: string) => {
  const res = await axios.get("teleconsultation", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const checkCoverage = async (authToken: string) => {
  const res = await axios.get("/teleconsult/check-coverage", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return res.data;
};